import React, { useContext, useEffect, useState } from "react";
import { advertisementByUser } from "../actions/advertisementByUser";
import { UserContext } from "../context/MainContext";
import { useNavigate } from "react-router-dom";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";

const AdDash = () => {
  const { user, setUser } = useContext(UserContext);
  const [advertisement, setAdvertisement] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    advertisementByUser(user?.user_id, { setAdvertisement });
  }, [user]);
  return (
    <div className="border-2 mt-8 p-4 h-[80vh]">
      <h1 className="text-30">Ad Dashboard</h1>
      <hr />
      {advertisement?.length > 0 ? (
        <>
          <table className="w-full text-center mt-8 border-2">
            <tr>
              <th className="border-b-2">Advertisement Picture</th>
              <th className="border-b-2">Orientation</th>
              <th className="border-b-2">Impressions</th>
            </tr>
            {advertisement.map((ad, index) => (
              <tr>
                {ad.advertisement_type === "Profile" ? (
                  <td
                    className={
                      index % 2 === 1
                        ? "bg-slate-300 text-blue-500 hover:cursor-pointer underline"
                        : "text-blue-500 hover:cursor-pointer underline"
                    }
                  >
                    <a
                      href={`/user/${ad.user_id}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {ad.advertisement_url}
                    </a>
                  </td>
                ) : (
                  <td
                    className={
                      index % 2 === 1
                        ? "bg-slate-300 text-blue-500 hover:cursor-pointer underline"
                        : "text-blue-500 hover:cursor-pointer underline"
                    }
                  >
                    <a
                      href={cloudinaryUrl(ad.advertisement_url)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {ad.advertisement_url}
                    </a>
                  </td>
                )}
                <td className={index % 2 === 1 ? "bg-slate-300" : ""}>
                  {ad.alignment}
                </td>
                <td className={index % 2 === 1 ? "bg-slate-300" : ""}>
                  {ad.impressions}
                </td>
              </tr>
            ))}
          </table>
          <p className="text-center mt-4 w-full">
            You have a total of {advertisement.length} active ads.
          </p>
        </>
      ) : (
        <p className="text-center pt-4 text-red-500">You have no active ads.</p>
      )}
    </div>
  );
};

export default AdDash;
